import styled, { css } from 'styled-components';

import { rem, toRemString } from '../../utils';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;

export const StyledDropdownOptionsContainer = styled.div`
  display: grid;
  overflow-x: hidden;
  overflow-y: auto;

  ${({ theme }) => css`
    grid-gap: ${rem(theme.Spacing.Size.XXSmall)};
    grid-template-columns: repeat(auto-fill, minmax(${rem(theme.Sizes.X4Large)}, 1fr));
    width: 100%;
    gap: ${rem(theme.Spacing.Size.XXSmall)};
    padding: ${rem(theme.Spacing.Size.XXSmall)};
    max-height: ${rem(theme.Form.SelectSize.Small)};
    ${theme.Scrollbar.Default}
  `}
`;

export const StyledDropdownOptionWrapper = styled.div`
  display: flex;
  width: 0;
  user-select: none;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
`;

export const StyledLabelContainer = styled.div<{
  isOpened: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  user-select: none;
  word-wrap: break-word;
  white-space: nowrap;
  cursor: pointer;

  ${({ theme, isOpened }) => css`
    gap: ${rem(theme.Spacing.Size.XSmall)};
    border: ${rem(theme.Border.Size.Small)} solid
      ${isOpened ? theme.Color.System.Primary : theme.Color.Neutrals.Border};
    border-radius: ${rem(theme.Border.Radius.Small)};
    background-color: ${theme.Components.Panel.Background};
    padding: ${toRemString([
      theme.Spacing.Size.XSmall,
      theme.Spacing.Size.XSmall,
      theme.Spacing.Size.XSmall,
      theme.Spacing.Size.XXSmall,
    ])};
    max-height: ${rem(theme.Form.InputSize.Medium.height)};
  `}
`;

export const StyledColorIconPrefix = styled.div`
  display: flex;
  align-items: baseline;
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const StyledPaletteContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledPaletteSelectorContainer = styled.div``;

export const StyledPaletteDropdown = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
